module.exports = __webpack_public_path__ + "static/img/202311.3503ca9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brand/202311.png
// module id = 8AcI
// module chunks = 0